<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title style="font-size: 20px; color: white"
              >ร้าน {{ store_name }}</v-list-tile-title
            >
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn
              icon
              @click="$store.commit('storeBack/setStoreName', null)"
              v-if="checkRouteStore()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            v-for="subItem in item.items"
            :key="subItem.title"
            :to="
              subItem.id == 1
                ? '/weserve_admin_login/control/' +
                  $store.state.backOffice.province +
                  '/storeandproduct/store/' +
                  $store.state.storeBack.store_detail_id +
                  '/storeinfo'
                : subItem.url
            "
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
      <v-list v-for="(item, index) in option" :key="index">
        <v-list-tile :to="item.url">
          <v-list-tile-action>
            <v-icon>{{ item.action }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      store_name: (state) => state.storeBack.store_name,
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      let arr = [
        {
          action: "assignment",
          permission_name: "store_list",
          title: "Store",
          items: [
            {
              id: 1,
              title: "Store Info",
              url: "",
            },
          ],
        },
        {
          action: "fastfood",
          title: "Product Management",
          permission_name: "product_list",
          items: [
            {
              id: 4,
              title: "Product Type",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/storeandproduct/store/" +
                this.$store.state.storeBack.store_detail_id +
                "/producttype",
            },
            {
              id: 3,
              title: "Product List",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/storeandproduct/store/" +
                this.$store.state.storeBack.store_detail_id +
                "/product",
            },
            // {
            //   id: 5,
            //   title: "Option List",
            //   url:
            //     "/weserve_admin_login/control/" +
            //     this.$store.state.backOffice.province +
            //     "/storeandproduct/store/" +
            //     this.$store.state.storeBack.store_detail_id +
            //     "/option",
            // },
          ],
        },
      ];
      return arr.filter((val) => {
        for (let val2 in this.permission.store_and_product) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
    option() {
      let option = [
        {
          action: "mdi-list-box",
          permission_name: "store_list",
          title: "Option Management",
          url:
            "/weserve_admin_login/control/" +
            this.$store.state.backOffice.province +
            "/storeandproduct/store/" +
            this.$store.state.storeBack.store_detail_id +
            "/" +
            this.$store.state.storeBack.store_name +
            "/option_management",
        },
      ];
      return option.filter((val) => {
        for (let val2 in this.permission.store_and_product) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
  methods: {
    checkRouteStore() {
      let path_split = this.$route.fullPath.split("/");
      if (path_split[5] == "store") return false;
      else return true;
    },
  },
};
</script>
